<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="filterReady">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div slot="header">Advance Filter</div>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 lg4>
                    <v-select :items="allDocStates" v-model="filterData.docState"
                              label="Document State" autocomplete @input="doFiltering" clearable />
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field label="Batch No" v-model="filterData.batchno" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-select :items="outstandingStates" v-model="filterData.sppdState"
                              label="SPPD State" autocomplete @input="doFiltering" clearable />
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field label="Imposition Name" v-model="filterData.impositionName" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg4>
                    <v-text-field label="Employee Name" v-model="filterData.employeeName" @input="doFiltering"
                                  clearable />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <date-time-picker label="From Date" v-model="filterData.fromDate" date-only @input="doFiltering"
                                      clearable :rules="rules.fromdate" />
                  </v-flex>
                  <v-flex xs12 lg3>
                    <date-time-picker label="To Date" v-model="filterData.toDate" date-only @input="doFiltering"
                                      clearable :rules="rules.todate" />
                  </v-flex>
                  <v-flex xs12 lg2>
                    <v-select :items="paginationSizes" label="Item(s) per page"
                              :value="paginationSize"
                              @input="setPaginationSize" />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-flex xs12>
      <template v-if="loaded">
        <div class="text-xs-center" v-if="pagination.totalPages > 1">
          <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
        </div>
        <template v-if="realizations.length > 0">
          <v-list v-for="item in realizations" :key="item.id">
            <router-link :to="edit(item)">
              <realization-card :value="item"></realization-card>
            </router-link>
          </v-list>
        </template>
        <h2 class="text-lg-center" v-else>No Business Trip Realization Yet</h2>
        <div class="text-xs-center" v-if="pagination.totalPages > 1">
          <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
        </div>
      </template>
      <h2 v-else>Loading...</h2>
    </v-flex>
  </v-layout>
</template>

<script>
import Vuex from 'vuex'
import RealizationCard from './RealizationCard'
import Promise from 'promise-polyfill'
import DateTimePicker from '@/components/lookup/DateTimePicker'
import _ from 'lodash'
import moment from 'moment'

const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')
const genericStore = Vuex.createNamespacedHelpers('Generic')

export default {
  name: 'BtRealization',
  components: {
    RealizationCard,
    DateTimePicker
  },
  data () {
    return {
      title: 'Business Trip Realization',
      pagination: {},
      buttons: [
        {label: 'Add New', tooltip: 'Add New', icon: 'add', to: {name: 'business-trip-realization-select-sppd'}},
        {label: 'Refresh', tooltip: 'Refresh', icon: 'refresh', handler: this.loadResources}
      ],
      loaded: false,
      page: 1,
      filterData: {
        docState: '',
        impositionName: '',
        employeeName: '',
        batchno: '',
        fromDate: null,
        toDate: null,
        sppdState: ''
      },
      filterReady: false,
      rules: {
        fromdate: [
          v => v === null || this.filterData.toDate === null || this.filterData.fromDate <= this.filterData.toDate || 'Invalid date'
        ],
        todate: [
          v => v === null || this.filterData.fromDate === null || this.filterData.fromDate <= this.filterData.toDate || 'Invalid date'
        ]
      }
    }
  },
  computed: {
    realizations () {
      return this.pagination.content
    },
    ...genericStore.mapState({
      allDocStates: 'allDocStates',
      outstandingStates: 'outstandingStates'
    }),
    paginationSize () {
      return this.$store.getters.paginationSize
    },
    paginationSizes () {
      return this.$store.getters.paginationSizes
    }
  },
  methods: {
    ...btRealizationStore.mapActions({
      getPagination: 'getPagination',
      filter: 'filter'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    ...genericStore.mapActions({
      listAllDocStates: 'listAllDocStates',
      listOutstandingStates: 'listOutstandingStates'
    }),
    loadResources () {
      const self = this
      const promises = [self.listAllDocStates({vueinstance: self}), self.listOutstandingStates({vueinstance: self})]
      Promise.all(promises).then(res => { self.filterReady = true }).catch(err => self.$error(err))
      self.gotoPage(self.page)
      self._setupToolbar()
    },
    _setupToolbar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.buttons)
    },
    edit (item) {
      return {name: 'business-trip-realization-detail',
        params: {
          id: item.id,
          backRoute: {
            name: this.$route.name
          }
        }}
    },
    gotoPage (page) {
      const self = this
      self.page = page
      self._doFiltering()
    },
    _doFiltering () {
      const self = this
      self.loaded = false
      self.filter({
        vueinstance: self,
        page: self.page - 1,
        ds: self.filterData.docState,
        spstate: self.filterData.sppdState,
        empokey: self.filterData.impositionName,
        empkey: self.filterData.employeeName,
        batchno: self.filterData.batchno,
        tdate: self.filterData.toDate === null ? '' : moment(self.filterData.toDate).format('YYYYMMDD'),
        fdate: self.filterData.fromDate === null ? '' : moment(self.filterData.fromDate).format('YYYYMMDD'),
        size: this.paginationSize
      })
        .then(res => {
          if (self.page > res.totalPages && res.totalPages > 0) {
            self.page = 1
            self._doFiltering()
          } else {
            self.pagination = res
            self.loaded = true
          }
        }).catch(err => self.$error(err))
    },
    doFiltering: _.debounce(function () { this._doFiltering() }, 500),
    setPaginationSize (value) {
      this.$store.dispatch('setPaginationSize', {size: value, func: this.doFiltering})
    }
  },
  mounted () {
    if (this.$route.params.filter === 1) {
      this.filterData.docState = 'DRAFTED'
    } else if (this.$route.params.filter === 2) {
      this.filterData.docState = 'SUBMITTED'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadResources())
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bt-realization/BtRealization.vue